// import React from "react";
// import { useHistory } from "react-router-dom";
export async function handleResponse(response) {
  // let history = useHistory();
  if (response.ok) return response.json();
  if (response.status === 404) {
    const error = await response.text();
    throw new Error(error);
  }
  if (response.status === 401) {
    const error = await response.text();
    // history.push("/Logout");
    throw new Error(error);
  }
  if (response.status === 500) {
    const error = await response.text();
    throw new Error(error);
  }
  if (response.status === 400) {
    const error = await response.text();
    throw new Error(error);
  }
  if (response.status === 204) {
    const error = await response.text();
    throw new Error(error);
  }
}

export function handleError(error) {
  console.error("API call failed. " + error);
  throw error;
}
